import { reactive } from 'vue'

let resolve, reject
const state = reactive({})

export function useConfirmDialog() {
  return {
    show: ({
      type = 'info',
      title = 'Are you sure?',
      confirmText = 'Confirm',
      cancelText = 'Cancel',
      body = '',
      items = []
    } = {}) => {
      state.title = title
      state.body = body
      state.items = items
      state.cancelText = cancelText
      state.confirmText = confirmText
      state.type = type
      state.action = new Promise((res, rej) => {
        resolve = res
        reject = rej
      })
      state.show = true
      return state.action
    },
    accept: () => {
      resolve()
      state.show = false
    },
    cancel: () => {
      reject('cancelled')
      state.show = false
    },
    state
  }
}

export function useHardError() {
  const { show: showConfirm } = useConfirmDialog()
  return {
    show: async ({ message, confirmText = 'Ok', cancelText = null }) => {
      return showConfirm({
        type: 'danger',
        title: 'Error Notification',
        body: message,
        confirmText: confirmText,
        cancelText: cancelText
      })
    }
  }
}
